import { render, staticRenderFns } from "./KynatOnboarding.vue?vue&type=template&id=20e2267b&scoped=true"
import script from "./KynatOnboarding.vue?vue&type=script&lang=js"
export * from "./KynatOnboarding.vue?vue&type=script&lang=js"
import style0 from "./KynatOnboarding.vue?vue&type=style&index=0&id=20e2267b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2267b",
  null
  
)

export default component.exports